import angular from 'angular';

import Dashboard from './DashboardComponent';
import Service from './DashboardService';
import PanelTypesConfig from './PanelTypesConfig';

// // Base Panels
import pc3Panel from './pc3PanelDirective';
import PanelHeader from './PanelHeaderComponent';


// // Specialized Panels
import cameraPanel from './cameraPanel';
import dialPanel from './dialPanel';
import editPanel from './editPanel';
import equipmentMapPanel from './equipmentMapPanel';
import eventsPanel from './eventsPanel';
import gasMeterPanel from './gasMeterPanel';
import genericPanel from './genericPanel';
import graphPanel from './graphPanel';
import monitoringActionsPanel from './monitoringActionsPanel';
import SitePanel from './sitePanel';
import BarGraphPanel from './barGraphPanel';
import SmartlockPanel from './smartlockPanel';
import portalPanel from './portalPanel';
import shutoffPanel from './shutoffThresholdPanel';
import statusPanel from './statusPanel';
import tankPanel from './tankPanel';
import tripWirePanel from './tripWirePanel';
import voiceDownPanel from './voiceDownPanel';
import weatherPanel from './weatherPanel';


export default angular
  .module('petroCloud.dashboard', [
    cameraPanel,
    dialPanel,
    editPanel,
    equipmentMapPanel,
    eventsPanel,
    gasMeterPanel,
    genericPanel,
    graphPanel,
    monitoringActionsPanel,
    SitePanel,
    BarGraphPanel,
    SmartlockPanel,
    portalPanel,
    shutoffPanel,
    statusPanel,
    tankPanel,
    tripWirePanel,
    voiceDownPanel,
    weatherPanel,
  ])
  .component(Dashboard.name, Dashboard)
  .component(PanelHeader.name, PanelHeader)
  .constant('PanelTypes', PanelTypesConfig)
  .directive('pc3panel', pc3Panel)
  .service('DashboardService', Service)
  .name;
